export default __webpack_public_path__ + "static/media/left-arrow.4cf89f37.svg";